import { BaseError } from '@bigmi/core';
export class ChainNotConfiguredError extends BaseError {
    constructor(chainId) {
        super(`Chain ${chainId ? `: ${chainId}` : ''} not configured.`);
        this.name = 'ChainNotConfiguredError';
    }
}
//# sourceMappingURL=config.js.map